import * as v from "valibot";

import { rpcContract } from "../rpc";

export const impersonateInfluencerRpcContract = rpcContract({
  name: "impersonateInfluencer",
  paramsSchema: v.object({
    influencerId: v.string(),
  }),
  resultSchema: v.object({
    accessToken: v.string(),
    handle: v.optional(v.string()),
  }),
});

export type ImpersonateInfluencerParams = v.InferOutput<(typeof impersonateInfluencerRpcContract)["paramsSchema"]>;
export type ImpersonateInfluencerResult = v.InferOutput<(typeof impersonateInfluencerRpcContract)["resultSchema"]>;
